import { NgClass } from '@angular/common';
import { Component, computed, input, signal } from '@angular/core';
import { RouterNavState } from '@app/core/store/states/router-nav/router-nav.state';
import { IsOauthApp } from '@app/core/utilities/app.utilities';
import { RemoveLoader } from '@app/core/utilities/dom.utilities';
import { select } from '@ngxs/store';
import { NzContentComponent, NzHeaderComponent } from 'ng-zorro-antd/layout';
import { GlobalSideNavComponent } from '../global-side-nav/global-side-nav.component';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'adspt-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [NzHeaderComponent, HeaderComponent, NzContentComponent, NgClass, GlobalSideNavComponent],
  host: {
    '[class.ant-layout]': 'true',
  },
})
export class LayoutComponent {
  readonly disableLinks = input(false);

  readonly isFluidLayout = select(RouterNavState.dataParam('isFluid'));
  readonly isFullWidth = select(RouterNavState.dataParam('fullWidth'));

  readonly isOauthApp = signal(IsOauthApp());
  readonly layoutClass = computed(() =>
    this.isFullWidth() ? 'container-full-width' : this.isFluidLayout() ? 'container-fluid' : 'container',
  );

  constructor() {
    RemoveLoader();
  }
}
